const NewPlanStage = Object.freeze({
  Info: 'info',
  Details: 'details',
  Financial: 'financial',
  Cover: 'cover',
  Linked: 'linked',
  Crystalisation: 'crystalisation',
  Claims: 'claims',
  PremiumContribution: 'contribution',
  Proposal: 'proposal',
});

const stages = Object.freeze(Object.keys(NewPlanStage));

const PlanStatus = Object.freeze({
  Active: 'active',
  Inactive: 'inactive',
  Proposed: 'proposed',
});

const PlanTypes = Object.freeze({
  Annuity: 'annuity',
  CashAccount: 'cash_account',
  FixedAsset: 'fixed_asset',
  GeneralInsurance: 'general_insurance',
  GroupProtection: 'group_protection',
  Investment: 'investment',
  LoanCredit: 'loan_credit',
  Mortgage: 'mortgage',
  Pension: 'pension',
  ProtectionPolicy: 'protection_policy',
});

const CoverPlanTypes = Object.freeze({
  Insurance: 'insurance',
  Protection: 'protection',
});

const allowedPlanTypes = {
  'plans-id-PlanDetails': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-WrapDetails': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-sub-accounts': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-transactions': [
    'annuity',
    'cash_account',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-Financial': ['annuity', 'cash_account', 'investment', 'loan_credit', 'mortgage', 'pension'],
  'plans-id-Cover': ['general_insurance', 'group_protection', 'protection_policy'],
  'plans-id-Linked': [
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-Crystallisation': ['pension'],
  'plans-id-Claims': ['general_insurance', 'group_protection', 'protection_policy'],
  'plans-id-Premium': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-ProposalTracking': ['mortgage'],
  'plans-id-CustomFields': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-charges': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-charge-splits': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-cases': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-documents': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-notes': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
  'plans-id-tasks': [
    'annuity',
    'cash_account',
    'fixed_asset',
    'general_insurance',
    'group_protection',
    'investment',
    'loan_credit',
    'mortgage',
    'pension',
    'protection_policy',
  ],
};

module.exports = { NewPlanStage, PlanStatus, stages, PlanTypes, CoverPlanTypes, allowedPlanTypes };
